/**
 * Module dependencies.
 */

import React from 'react';
import { InputSearch } from '../form-filters-type';
import { FilterOptions } from './types';
import { cn } from 'app/lib/utils';
import { FilterInputField } from './filter-input-field';

/**
 * Export `FilterInputSearchField` component.
 */

export function FilterInputSearchField({ className, ...rest }: FilterOptions<InputSearch>): JSX.Element {
  return <FilterInputField className={cn(className, 'min-w-[350px] max-[600px]:min-w-full')} {...rest} />;
}
